import { Directive, ElementRef, HostListener } from '@angular/core';
import { Store } from '@ngrx/store';
import { notify } from 'app/store/common-effects/notifier.effects';
import { ClipboardService } from 'ngx-clipboard';

@Directive({
  selector: '[copyable]',
  host: { '[style.cursor]': '"pointer"' },
  standalone: false,
})
export class CopyableDirective {
  constructor(private clipboardService: ClipboardService, private store$: Store, private el: ElementRef) { }

  @HostListener('click') copy(): void {
    this.clipboardService.copyFromContent(this.el.nativeElement.innerText);
    this.store$.dispatch(notify({ message: 'NOTIFICATIONS.copied' }));
  }
}
